<div
  class="bg-gradient min-vh-100 d-flex flex-row align-items-center auth-page-bg"
>
  <c-container breakpoint="md">
    <c-row class="justify-content-center">
      <c-col lg="8" xl="8">
        <div class="d-flex flex-column justify-content-center align-items-center">
            <img
            src="assets/images/app/manosya/manosya-logo.svg"
            alt="Logo Manosya"
            class="login-logo mb-4"
            style="width: 40%; height: 10rem"
          />
          <c-card style="max-width: 60%; width: 60%" class="rounded-5 p-4">
            <c-card-body>
              <h3 cCardTitle class="mb-4">{{title}}</h3>
              <ng-content select="[auth-content]"></ng-content>
            </c-card-body>
          </c-card>

          <div class="mt-3 d-flex justify-content-end" style="max-width: 60%; width: 100%">
            <ng-content select="[auth-footer]"></ng-content>
          </div>
        </div>
      </c-col>
    </c-row>
  </c-container>
</div>
